import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { useSubtotals } from '../../context/SubtotalsProvider';
import { isFutureBilledSubtotal } from '../../types/utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscountValue = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "span",
  color: "fill-positive-default",
  typography: "heading-25",
  children: children
});
const RecurringDiscountMessage = () => {
  const {
    discountCodeResponse,
    recurringSubtotals
  } = useSubtotals();
  const discount = discountCodeResponse === null || discountCodeResponse === void 0 ? void 0 : discountCodeResponse.checkoutSessionDiscount;
  if (!(discountCodeResponse !== null && discountCodeResponse !== void 0 && discountCodeResponse.isValid) || (discount === null || discount === void 0 ? void 0 : discount.durationType) !== 'RECURRING' || discount.valueType !== 'PERCENT' || !recurringSubtotals.some(isFutureBilledSubtotal)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "small",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.futureCharges.recurringDiscountApplied_jsx",
      options: {
        discountCode: discountCodeResponse.discountCode,
        discountValue: `${discount.value}%`
      },
      elements: {
        DiscountValue
      }
    })
  });
};
export default RecurringDiscountMessage;